<template>
	<div>
		<div class="actDiv" title="楼宇统计">
			<label>小区</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区"
				option-filter-prop="children" :filter-option="filterOption" show-search @change="getDateList"
				label-in-value>
				<a-select-option v-for="(item,index) in searchneighborList" :key="item.pId" :value="item.pId">
					{{item.neighborName}}
				</a-select-option>
			</a-select>
			<label>结算</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theSettle" show-search label-in-value
				option-filter-prop="children" :filter-option="filterOption">
				<a-select-option v-for="(item,index) in dateList" :key="item.PID" :value="item.PID">
					{{getTime(item.StartTime)}}
				</a-select-option>
			</a-select>
			<label>楼</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.lou" option-filter-prop="children"
				:filter-option="filterOption" show-search>
				<a-select-option v-for="(item,index) in lousList" :key="item.id" :value="item.lou">
					{{item.lou}}
				</a-select-option>
			</a-select>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.pre" option-filter-prop="children"
				:filter-option="filterOption" show-search>
				<a-select-option v-for="(item,index) in payList" :value="item.value">{{item.label}}
				</a-select-option>
			</a-select>
			<a-button   @click="query" style="margin: 0 0.625rem;" size="small" icon="search">查找</a-button>
			<a-button   @click="print" style="margin: 0 0.625rem;" size="small" icon="printer">打印</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="450"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"    row-id="c_id"  :cell-style="cellClassName">
						  <vxe-table-column type="seq" width="60"></vxe-table-column>
						  <vxe-table-column title="用户号" field="c_num" ></vxe-table-column>
						  <vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
						  <vxe-table-column title="地址" field="customerAddr" ></vxe-table-column>
						  <vxe-table-column title="手机" field="CustomerMobile" width="100"></vxe-table-column>
						  <vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
						  <vxe-table-column title="余额阀值" field="warnThre"></vxe-table-column>
						  <vxe-table-column title="表状态" field="meterState" :formatter="getMeterState"></vxe-table-column>
						  <vxe-table-column title="单价" field="pricekindname"></vxe-table-column>
						  <vxe-table-column title="扣费读数" field="lastderead"></vxe-table-column>
						  <vxe-table-column title="阶梯起始" field="destartread"></vxe-table-column>
						 <vxe-table-column title="表读数" field="meterread"></vxe-table-column>
						  <vxe-table-column title="换表底数" field="changeend"></vxe-table-column>
						  <vxe-table-column title="抄表时间" field="meterreadtime" :formatter="getTimeFormatter" width="140"></vxe-table-column>
						  <vxe-table-column title="用量" field="yl">
						  	<template #default="{ row }">
						  		<span>
						  			{{getYL(row)}}
						  		</span>
						  	</template>
						  </vxe-table-column>
						  <vxe-table-column title="阶梯" field="formula" ></vxe-table-column>
						  <vxe-table-column title="减免" field="minusderead"></vxe-table-column>
						  <vxe-table-column title="转到虚表" field="tovirtual" ></vxe-table-column>
						  <vxe-table-column title="扣费金额" field="demoney"></vxe-table-column>
		</vxe-table>
		<a-row :gutter="5" style="margin-top: 1.25rem;">
			<a-col :span="6">
				<a-table size="small" :columns="settledYLcolumns" :data-source="getSettledYL" bordered
					:pagination="false" :rowKey="settledYLcolumns.pricekindname" :loading="loading">
				</a-table>
			</a-col>
			<a-col :span="6">
				<a-table size="small" :columns="listjietiylcolumns" :data-source="listjietiyl" bordered
					:pagination="false" :rowKey="listjietiylcolumns.name" :loading="loading">
				</a-table>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default {
		data() {
			const settledYLcolumns = [{
					title: '单价',
					dataIndex: 'pricekindname',
					width: 80,
					className:'v-cell',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					width: 80,
					className:'v-cell',
				},
				{
					title: '扣费金额',
					dataIndex: 'demoney',
					width: 80,
					className:'v-cell',
				}
			];

			const listjietiylcolumns = [{
					title: '一阶用量 ',
					dataIndex: 'firstyl',
					width: 80,
					className:'v-cell',
				},
				{
					title: '二阶用量 ',
					dataIndex: 'secondyl',
					width: 80,
					className:'v-cell',
				},
				{
					title: '三阶用量 ',
					dataIndex: 'thirdyl',
					width: 80,
					className:'v-cell',
				}
			];
			return {
				settledYLcolumns,
				listjietiylcolumns,
				loading: false,
				selectedRowKeys: [],
				searchmodel: {
					n_id: 0,
					pre: 1,
					lou: null,
					settle_id: null,
				},
				lousList: [],
				dateList: [],
				getSettledYL: [],
				listjietiyl: [],
				list: [],
				searchneighborList: [],
				theNeighbor: undefined,
				theSettle: undefined,
				payList: [{
						value: 1,
						label: "预付费"
					},
					{
						value: 0,
						label: "后付费"
					},
					{
						value: 2,
						label: "全部"
					},
				],
				payTypeList: [
					{
						value: 3,
						label: "微信支付缴费"
					},
					{
						value: 2,
						label: "招商银行缴费"
					},
					{
						value: 1,
						label: "支付宝缴费"
					},
					{
						value: 0,
						label: "营业厅缴费"
					},
					{
						value: -1,
						label: "请选择"
					},
				],
			}
		},

		methods: {
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(column.property == 'CustomerBalance'){
					if(row.CustomerBalance<=0){
						 style =  {
							 backgroundColor: '#ffee00',
							 color: '#ff0000'
						 }
					}
				} else if(column.property == 'meterState'){
					if(row.meterState !=1){
						style = {
								'color':'#ff0000',
						}
					}
				}else{
					style = {
							'color':'#000',
					}	
				}	
				return style;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getYL(row) {
				if (row.changeend > 0) {
					return row.meterread + row.changeend - row.lastderead;
				} else {
					return row.meterread - row.lastderead;
				}
			},
			getDateList(value) {
				console.log(value);
				this.searchmodel.n_id = value.key;
				this.searchmodel.settle_id = null;
				this.searchmodel.lou = null;
				this.theSettle = undefined,
				this.dateList = [];
				this.lousList = [];
				this.querylistsettled();
				this.queryLous();
			},
			onChange() {

			},
			meterStateCell(record) {
				if (record.meterState != 1 ) {
					return {
						style: {
							'color': '#ff0000',
						}
					}
				}
			},
			onSelectChange(selectedRowKeys, selectedRows) {
				let c_ids = '';
				let pay_pid_ids = '';
				for (var i = 0; i < selectedRows.length; i++) {
					var row = selectedRows[i];
					if (i != 0) {
						c_ids += "-";
						pay_pid_ids += "-";
					}
					c_ids += row.c_id;
					pay_pid_ids += row.pay_pid;
				}
				this.selectedRowKeys = selectedRowKeys;
			},
			getPreState: function(prepaysign) {
				if (prepaysign == 1) {
					return '预';
				}
				if (prepaysign == 0) {
					return '后';
				}
			},
			getPayTypeState: function(paytype) {
				if(paytype == 3){
					return '微信支付';
				}else if (paytype == 2) {
					return '招商银行';
				}else if (paytype == 1) {
					return '支付宝';
				} else if (paytype == 0) {
					return '营业厅';
				} else {
					return '其他';
				}
			},
			getName: function(paytype) {
				if(paytype == 3){
					return '微信支付'
				}else if(paytype == 2){
					return '招商银行'
				}else if (paytype == 1) {
					return '支付宝';
				} else if (paytype == 0) {
					return '营业厅';
				} else {
					return '合计';
				}
			},
			getTime: function(actionTime) {
				let date = new Date(actionTime);
				return this.Config.formatDate(date);
			},
			print: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_LOU_PRINT_URL);
				if (this.searchmodel.n_id == 0) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theNeighbor == undefined) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theNeighbor != undefined) {
					this.searchmodel.n_id = this.theNeighbor.key;
					this.searchmodel.n_name = this.theNeighbor.label;
				} else {
					this.searchmodel.n_name = '';
				}
				if (this.theSettle != undefined) {
					this.searchmodel.settle_id = this.theSettle.key;
					this.searchmodel.settle_time = this.theSettle.label;
				}
				if (this.searchmodel.settle_id == null) {
					this.$message.info("请选择结算");
					return;
				}
				if (this.searchmodel.lou == null) {
					this.$message.info("请选择楼层");
					return;
				}
				let userInfo = this.Config.getUserLocal();
				window.open(url + "?n_id=" + this.searchmodel.n_id + "&lou=" + this.searchmodel.lou + "&n_name=" + this
					.searchmodel.n_name +
					"&pre=" + this.searchmodel.pre + "&settle_id=" + this.searchmodel.settle_id + "&settle_time=" +
					this.searchmodel.settle_time, "_blank");
			},
			query: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_LOULOGALL_URL);
				if (this.searchmodel.n_id == 0) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theNeighbor == undefined) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theSettle != undefined) {
					this.searchmodel.settle_id = this.theSettle.key;
					this.searchmodel.settle_time = this.theSettle.label;
				}
				if (this.searchmodel.settle_id == null) {
					this.$message.info("请选择结算");
					return;
				}

				this.loading = true;
				this.Api.fetchPost(url, this.searchmodel).then((data) => {
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.list = result.lous;
						this.getSettledYL = result.louSettledYL;
						this.listjietiyl = result.louJietiYL;
					} else {
						this.$message.error(msg);

					}
				}).catch((error) => {
					console.log(error);
					this.loading = false;
				});
				

			},
			queryNeighbors: function() {
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.searchneighborList = result;
					} else {
						this.$message.error(msg);

					}
				}).catch((error) => {
					console.log(error);
				});
			},
			queryLous: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_GETLOUS_URL);
				let n_id = this.searchmodel.n_id;
				this.Api.fetchPost(url, {
					n_id,
					n_id
				}).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.lousList = result;

					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			querylistsettled: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_List_Settle_Log_URL);
				let n_id = this.searchmodel.n_id;
				this.Api.fetchPost(url, {
					n_id,
					n_id
				}).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.dateList = result;

					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
